export default __webpack_public_path__ + "static/media/kyselyt-taytetyt-white.38d39eb4.svg";